import { useEffect, useState } from "react";
import SelectMultiple from "./SelectMultiple"; // Asegúrate de que la ruta es correcta
import IconSelector from "./IconSelector/IconSelector";

const DataSelector = ({ rawData, value, onChange, label = "Seleccionar indicador", ...props }) => {
    const [options, setOptions] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!rawData || typeof rawData !== 'object') {
            setOptions([]);
            setIsLoading(false);
            // console.log("No rawData provided or invalid format");
            return;
        }

        // Verificamos si los datos están agrupados por término
        const isGroupedByTerm = Array.isArray(Object.values(rawData)[0]);
        console.log("isGroupedByTerm:", isGroupedByTerm);
        console.log("Raw Data:", rawData);
        // Transformamos los datos a las opciones del select
        const transformedOptions = Object.entries(rawData).map(([groupKey, groupData]) => {
            const firstItem = Array.isArray(groupData)
                ? groupData[0]
                : Object.values(groupData)[0]?.[0];

            return {
                id: groupKey, // Usamos groupKey como id
                value: groupKey,
                name: firstItem?.indicator || groupKey.replace(/_/g, ' '), // name para compatibilidad
                label: firstItem?.indicator || groupKey.replace(/_/g, ' '),
                icon: firstItem?.icon_indicator || firstItem?.icon,
                color: firstItem?.color_card,
                description: firstItem?.description,
                image: null // Podrías convertir el icono a imagen si es necesario
            };
        });

        // console.log("Transformed Options:", transformedOptions);

        setOptions(transformedOptions);
        setIsLoading(false);
    }, [rawData]);

    // Formateador personalizado para mostrar iconos
    const formatOptionLabel = ({ label, icon, color, description }, { context }) => {
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {icon && context !== 'menu' && (
                    <div style={{
                        width: 24,
                        height: 24,
                        borderRadius: '50%',
                        backgroundColor: color || '#3B82F6',
                        marginRight: 8,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <IconSelector
                            value={icon} 
                            style={{ color: 'white', fontSize: 12 }} 
                        />
                    </div>
                )}
                <div>
                    <div>{label}</div>
                    {description && context === 'menu' && (
                        <div style={{ fontSize: 12, color: '#666' }}>
                            {description}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <SelectMultiple
            value={value}
            onChange={onChange}
            loading={isLoading}
            label={label}
            array={options}
            nameArray="label"
            formatOptionLabel={formatOptionLabel}
            {...props}
        />
    );
};

export default DataSelector;